import {
  Flag, FlagDeclaration, FlagEntities, FlagValue
} from './types';

export function flag<ValueType extends FlagValue, EntitiesType extends FlagEntities = FlagEntities>(
  definition: FlagDeclaration<ValueType, EntitiesType>
): Flag<ValueType, EntitiesType> {
  const flagFn = ( entities?: EntitiesType ) => {
    return evaluateFlag( definition, entities );
  };

  flagFn.definition = definition;

  return flagFn as Flag<ValueType, EntitiesType>;
}

function evaluateFlag<ValueType extends FlagValue, EntitiesType extends FlagEntities>(
  definition: FlagDeclaration<ValueType, EntitiesType>,
  entities?: EntitiesType
): ValueType {
  try {
    const value = definition.decide( { entities } );
    return value;
  } catch( error ) {
    console.error( `Error evaluating flag ${ definition.key }:`, error );
    return definition.defaultValue;
  }
}

export function evaluateAllFlags(
  flags: Flag<FlagValue, FlagEntities>[],
  entities?: FlagEntities
): Map<string, FlagValue> {
  const values = new Map<string, FlagValue>();

  for ( const flag of flags ) {
    const value = flag( entities );
    values.set( flag.definition.key, value );
  }

  return values;
}
